export const state = {
  isLoadong: false,
  isFileUpdate: false,
}

export type State={
  isLoadong: Boolean,
  isFileUpdate: Boolean
}
